import React, { useCallback } from 'react';
import { DialogControl } from 'spark-core-dx/components';
import '../../styles/convokeDialogPatterns.scss';

const getFailureMessage = (result, fallbackMessage) => (
  result?.DisplayMessage
  ?? result?.displayMessage
  ?? result?.Message?.DisplayMessage
  ?? result?.message?.displayMessage
  ?? fallbackMessage
  ?? 'The operation did not complete.'
);

const normalizeDialogResult = (result, fallbackMessage) => {
  if (result === undefined) return result;
  if (result?.Success === true) return result;
  if (result?.Success === false) {
    return {
      ...result,
      DisplayMessage: getFailureMessage(result, fallbackMessage),
    };
  }

  return {
    Success: true,
    Item: result,
  };
};

const ConvokeDialogControl = ({
  onOk,
  fallbackErrorMessage,
  onDialogActionError,
  keepOpenOnSuccess = false,
  ...props
}) => {
  const handleOk = useCallback(async (...args) => {
    try {
      const result = normalizeDialogResult(
        await onOk(...args),
        fallbackErrorMessage,
      );

      if (result?.Success === false) {
        onDialogActionError?.(result);
      }

      if (keepOpenOnSuccess && result?.Success === true) {
        return undefined;
      }

      return result;
    } catch (error) {
      const result = {
        Success: false,
        DisplayMessage: error?.message
          || fallbackErrorMessage
          || 'The operation did not complete.',
      };
      onDialogActionError?.(result);
      return result;
    }
  }, [fallbackErrorMessage, keepOpenOnSuccess, onDialogActionError, onOk]);

  return (
    <DialogControl
      {...props}
      className={`convoke-dialog${props.className ? ` ${props.className}` : ''}`}
      onOk={onOk ? handleOk : undefined}
    />
  );
};

export default ConvokeDialogControl;
